module.exports = __webpack_public_path__ + "static/media/logo.5ecae4e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Globals/Slide/logo.png
// module id = 687
// module chunks = 0